import React, { useState, useEffect } from "react";
import { BiSolidPhone } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { MdOutlineDoubleArrow } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { ImAppleinc } from "react-icons/im";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import logo from "../../assets/logo.png";
import { useSelector } from "react-redux";
import axios from "axios";

const Index = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    axios
      .get(`${baseURL}/contact/fetchcontactUs`)
      .then((response) => {
        setContactData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching contact data:", error);
      });
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid px-0" id="footer">
      <footer className="footer-top">
        <div className="container-xxl m-auto row m-0 px-0">
          <div className="col-lg-3">
            <div>
              <img src={logo} width="200px" />
              {/* <h2>theRides</h2> */}
              <p className="footer-description">
                {contactData?.description
                  ? contactData?.description
                  : "Description"}
              </p>
            </div>
          </div>
          <div className="col-lg-2 px-0">
            <h3 className="font">Contact Us</h3>
            <ul className="list-unstyled footer-contact">
              <li className="my-3">
                <BiSolidPhone className="footer-contact-icon" />
                {/* (704)555-0127 */}
                <span>{contactData?.phone ? contactData?.phone : ""}</span>
              </li>
              <li className="my-3">
                {" "}
                <MdEmail className="footer-contact-icon" />
                <span>{contactData?.email ? contactData?.email : ""}</span>
              </li>
            </ul>
          </div>
          <div className="col-lg-3">
            <h3 className="font">Information</h3>
            <ul className="list-unstyled footer-info">
              <li className="my-2" onClick={scrollToTop}>
                <Link to="/carlist">
                  <MdOutlineDoubleArrow /> Find a Car for Rent in the Nearest
                  Location
                </Link>
              </li>
              <li className="my-2" onClick={scrollToTop}>
                <Link to="/aboutus">
                  <MdOutlineDoubleArrow /> About us
                </Link>
              </li>
              <li className="my-2" onClick={scrollToTop}>
                <Link to="/termsandcondition">
                  <MdOutlineDoubleArrow /> Terms and condition
                </Link>
              </li>
              <li className="my-2" onClick={scrollToTop}>
                <Link to="/contactUs">
                  <MdOutlineDoubleArrow /> Help Center
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-4">
            <h3 className="font">Socials</h3>
            <div className="d-flex flex-row gap-5 my-3">
              <div>
                <FaFacebookF />
              </div>
              <div>
                <FaXTwitter />
              </div>
              <div>
                <FaInstagram />
              </div>
            </div>
            <div className="flex-app social-btns">
              <a
                className="app-btn blu flex vert"
                target="_blank"
                href="https://apps.apple.com/us/app"
              >
                <ImAppleinc className="download-icon" />
                <p>
                  Available on the <br />{" "}
                  <span className="big-txt">App Store</span>
                </p>
              </a>
              <a
                className="app-btn blu flex vert"
                target="_blank"
                href="https://play.google.com/store/apps"
              >
                <IoLogoGooglePlaystore className="download-icon" />
                <p>
                  Get it on <br /> <span className="big-txt">Google Play</span>
                </p>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <footer className="footer-bottom py-3 text-center">
        <p className="primaryColor">© 2024 | The Rides | All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default Index;
